module.exports = __webpack_public_path__ + "assets/images/logo-m-a-branco-54dd555a.svg?e7cf54e9a3a2fb462f47357998e2cb25";


//////////////////
// WEBPACK FOOTER
// ./_source/images/logo-m-a-branco-54dd555a.svg
// module id = 399
// module chunks = 0